import React, { createContext, useContext, useState, useEffect } from 'react';
import { api, useServer } from './ServerContext';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { server, setServer } = useServer();

  useEffect(() => {
    if (!server) return;
    checkAuth();
    // eslint-disable-next-line
  }, [server]);

  const checkAuth = async () => {
    if (!server) return;
    setLoading(true);
    try {
      let response = await api.get(`/api/auth/me?server=${server}`, { withCredentials: true });
      let u = response.data;
      setUser(u);
      // Если нет прав на выбранном сервере — ищем сервер с правами
      if (!u.isAdmin) {
        try {
          const res = await api.get('/api/auth/find-server');
          if (res.data.server && res.data.server !== server) {
            setServer(res.data.server);
          }
        } catch {}
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = () => {
    window.location.href = `/api/auth/steam?server=${server}`;
  };

  const logout = async () => {
    try {
      await api.get('/api/auth/logout', { withCredentials: true });
      setUser(null);
      setServer('ds1');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const value = {
    user,
    loading,
    login,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
} 